var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.979 0h-5.76c-.56 0-1.02.46-1.02 1.018 0 .56.46 1.018 1.02 1.018h3.28l-9.54 9.54c-.4.399-.4 1.037 0 1.437a1.016 1.016 0 0 0 1.441 0l9.56-9.52v3.273c0 .559.46 1.018 1.02 1.018S19 7.324 19 6.766V1.018C19 .46 18.54 0 17.978 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.34 9.44c-.56 0-1.021.46-1.021 1.019v4.091a2.382 2.382 0 0 1-2.38 2.375h-7.5A2.382 2.382 0 0 1 2.06 14.55V7.065A2.382 2.382 0 0 1 4.44 4.69h4.1c.56 0 1.02-.459 1.02-1.018 0-.559-.46-1.018-1.02-1.018h-4.1A4.438 4.438 0 0 0 0 7.086v7.484C0 17.004 1.98 19 4.44 19h7.5c2.44 0 4.44-1.976 4.44-4.43v-4.112a1.054 1.054 0 0 0-1.04-1.018"
  }))));
};
export default SvgExternalLink;